/* eslint-disable camelcase */
type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_the_only_yoga_membership_you_ll_ever_need: Phrase = locale => {
    const en = `The only yoga membership you’ll ever need.`;
    const phrases: { [key: string]: undefined | string } = {
        en,
        es: `¡La única membresía de yoga que vas a necesitar!`,
    };
    return phrases[locale] || en;
};
